import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { Observable, of, Subscription } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {
  DoctorService,
  PatientsService,
  PractitionRoleService,
} from '../../../../../../../../core/lists/_services';
import { Immunization, selectImmunizationsActionLoading } from '../../../../../../../../core/lists';
import { select, Store } from '@ngrx/store';

import { AppState } from '../../../../../../../../core/reducers';
import {
  ImmunizationOnServerCreated,
  ImmunizationOnServerUpdated,
} from '../../../../../../../../core/lists/_actions/immunization.actions';
import { selectImmunizationErrorState } from '../../../../../../../../core/lists/_selectors/immunization.selectors';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ConditionsService } from '../../../../../../../../core/lists/_services/condition.service';

@Component({
  selector: 'kt-immunization-edit',
  templateUrl: './immunization-edit.component.html',
})
export class ImmunizationEditComponent implements OnInit, OnDestroy {
  // Public properties
  immunization: Immunization;
  immunizationEditForm: FormGroup;
  hasFormErrors = false;
  hasSubmissionErrors = false;
  submissionErrorObj: any;
  viewLoading = true;
  loadingAfterSubmit = false;
  entityInputController;
  selectable = true;
  removable = true;
  filteredEntities: Observable<string[]>;
  entityList: string[] = [];
  @ViewChild('entityInput') entityInput: ElementRef<HTMLInputElement>;
  isCreate: boolean | boolean;

  // right
  filteredReason;
  @ViewChild('reasonInput') reasonInput: ElementRef<HTMLInputElement>;
  reasonList: any = [];

  filteredReasonCode;
  @ViewChild('reasonCodeInput') reasonCodeInput: ElementRef<HTMLInputElement>;
  reasonCodeList: any = [];

  filteredVaccine;
  @ViewChild('vaccineInput') vaccineInput: ElementRef<HTMLInputElement>;
  vaccineList: any = [];

  filteredActor;
  filteredPractitionerRole;
  @ViewChild('actorInput') actorInput: ElementRef<HTMLInputElement>;
  @ViewChild('actorInput1') actorInput1: ElementRef<HTMLInputElement>;
  actorList: any = [];
  actorList1: any = [];
  actorOption = '';

  filteredCondition;
  @ViewChild('conditionInput') conditionInput: ElementRef<HTMLInputElement>;
  conditionList: any = [];

  public subpotentReasons: Array<any> = [
    { display: 'Partial Dose', code: 'partial' },
    { display: 'Cold Chain Break', code: 'coldchainbreak' },
    { display: 'Manufacturer Recall', code: 'recall' },
  ];

  public reportOrigins: Array<any> = [
    { display: 'Other Provider', code: 'provider' },
    { display: 'Written Record', code: 'record' },
    { display: 'Parent/Guardian/Patient Recall', code: 'recall' },
    { display: 'School Record', code: 'school' },
  ];
  public routes: Array<any> = [
    { display: 'Injection, intradermal', code: 'IDINJ' },
    { display: 'Injection, intramuscular', code: 'IM' },
    { display: 'Inhalation, nasal', code: 'NASINHLC' },
    { display: 'Injection, intravenous', code: 'IVINJ' },
    { display: 'Swallow, oral', code: 'PO' },
    { display: 'Injection, subcutaneous', code: 'SQ' },
    { display: 'Transdermal', code: 'TRNSDERM' },
  ];

  public programEligibilitys: Array<any> = [
    { display: 'Not Eligible', code: 'ineligible' },
    { display: 'Uninsured', code: 'uninsured' },
  ];

  public functions: Array<any> = [
    { display: 'Ordering Provider', code: 'OP' },
    { display: 'Administering Provider', code: 'AP' },
  ];

  public sites: Array<any> = [
    { display: 'Left arm', code: 'LA' },
    { display: 'Right arm', code: 'RA' },
  ];

  public fundingSources: Array<any> = [
    { display: 'Private', code: 'private' },
    { display: 'Public', code: 'public' },
  ];

  filteredTargetDisease;
  @ViewChild('targetDiseaseInput') targetDiseaseInput: ElementRef<HTMLInputElement>;
  targetDiseaseList: any = [];

  // end right

  filteredManifestation;
  @ViewChild('manifestationInput') manifestationInput: ElementRef<HTMLInputElement>;
  manifestationList: any = [];

  filteredRecorder;
  @ViewChild('recorderInput') recorderInput: ElementRef<HTMLInputElement>;
  recorderList: any = [];
  condition = null;
  asserterSelected = false;
  private componentSubscriptions: Subscription;
  condetion;
  performer;

  private patientId: any;
  recorderOption = '';
  onsetTypeOption = '';
  isReadOnly = false;

  constructor(
    public dialogRef: MatDialogRef<ImmunizationEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private store: Store<AppState>,
    private conditionsService: ConditionsService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private patientsService: PatientsService,
    private practitionRoleService: PractitionRoleService,
    private doctorsService: DoctorService,
  ) {}

  ngOnInit() {
    this.isReadOnly = this.data.isReadOnly;
    this.immunization = this.data.immunization;
    this.patientId = this.data.entityId;
    this.store
      .pipe(select(selectImmunizationsActionLoading))
      .subscribe((res) => (this.viewLoading = res));
    if (this.immunization.reasonReference && this.immunization.reasonReference[0].id) {
      this.conditionsService
        .getResourceById('Condition', this.immunization.reasonReference[0].id)
        .subscribe((res) => {
          this.condition = res;
          this.immunizationEditForm.get('conditionSearch').setValue(this.condition);
        });
    }
    if (this.immunization.performer && this.immunization.performer[0].actor.id) {
      this.conditionsService
        .getResourceById(
          this.immunization.performer[0].actor.resourceType,
          this.immunization.performer[0].actor.id,
        )
        .subscribe((res) => {
          this.performer = res;
          if (this.immunization.performer[0].actor.resourceType === 'Practitioner') {
            this.immunizationEditForm.get('actorType').setValue('Practitioner');
            this.immunizationEditForm.get('actor1').setValue(res);
            this.actorOption = 'Practitioner';
          } else {
            this.immunizationEditForm.get('actorType').setValue('PractitionerRole');
            this.immunizationEditForm.get('actor2').setValue(res);
            this.actorOption = 'PractitionerRole';
          }
        });
    }

    this.createForm();
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    if (this.componentSubscriptions) {
      this.componentSubscriptions.unsubscribe();
    }
  }

  createForm() {
    this.immunizationEditForm = this.fb.group({
      status: [this.immunization.status, Validators.required],
      statusReason: [],
      vaccine: [null, Validators.required],
      occurrence: [
        this.immunization.occurrence !== null && this.immunization.occurrence !== undefined
          ? this.immunization.occurrence['dateTime']
          : null,
      ],
      recordedDate: [this.immunization.recorded],
      primarySource: [this.immunization.primarySource],
      reportOrigin: [],
      lotNumber: [this.immunization.lotNumber],
      expirationDate: [this.immunization.expirationDate],
      site: [],
      route: [],
      function: [],
      actorType: [],
      actor1: [],
      actor2: [],
      note: [
        this.immunization.note !== null && this.immunization.note !== undefined
          ? this.immunization.note[0].text
          : '',
        Validators.required,
      ],
      isSubpotent: [this.immunization.isSubpotent],
      subpotentReason: [],
      conditionSearch: [this.condition ? this.condition : null],
      documentType: [
        this.immunization.education && this.immunization.education[0] !== null
          ? this.immunization.education[0].documentType
          : null,
      ],
      reference: [
        this.immunization.education && this.immunization.education[0] !== null
          ? this.immunization.education[0].reference
          : null,
      ],
      presentationDate: [
        this.immunization.education && this.immunization.education[0] !== null
          ? this.immunization.education[0].presentationDate
          : null,
      ],
      publicationDate: [
        this.immunization.education && this.immunization.education[0] !== null
          ? this.immunization.education[0].publicationDate
          : null,
      ],
      programEligibility: [],
      fundingSource: [],
      targetDisease: [],
      reasonCode: [],
      doseNumber: [
        this.immunization.protocolApplied &&
        this.immunization.protocolApplied[0] !== null &&
        this.immunization.protocolApplied[0].doseNumber !== null
          ? this.immunization.protocolApplied[0].doseNumber.positiveInt
          : null,
      ],
      seriesDoses: [
        this.immunization.protocolApplied &&
        this.immunization.protocolApplied[0] !== null &&
        this.immunization.protocolApplied[0].seriesDoses !== null
          ? this.immunization.protocolApplied[0].seriesDoses.positiveInt
          : null,
      ],
      doseQuantityUnit: [
        this.immunization.doseQuantity ? this.immunization.doseQuantity.unit : null,
      ],
      doseQuantityValue: [
        this.immunization.doseQuantity ? this.immunization.doseQuantity.value : null,
      ],
      series: [
        this.immunization.protocolApplied && this.immunization.protocolApplied[0] !== null
          ? this.immunization.protocolApplied[0].series
          : null,
      ],
    });

    if (this.immunization.route && this.immunization.route.coding) {
      const selectedRoute = this.routes.find(
        (e) => e.code === this.immunization.route.coding[0].code,
      );
      this.immunizationEditForm.get('route').setValue(selectedRoute);
    }

    if (this.immunization.reportOrigin && this.immunization.reportOrigin.coding) {
      const selectedReportOrigin = this.reportOrigins.find(
        (e) => e.code === this.immunization.reportOrigin.coding[0].code,
      );
      this.immunizationEditForm.get('reportOrigin').setValue(selectedReportOrigin);
    }
    if (this.immunization.subpotentReason && this.immunization.subpotentReason[0].coding) {
      const selectedSubpotentReason = this.subpotentReasons.find(
        (e) => e.code === this.immunization.subpotentReason[0].coding[0].code,
      );
      this.immunizationEditForm.get('subpotentReason').setValue(selectedSubpotentReason);
    }

    if (this.immunization.site && this.immunization.site.coding) {
      const selectedSite = this.sites.find((e) => e.code === this.immunization.site.coding[0].code);
      this.immunizationEditForm.get('site').setValue(selectedSite);
    }

    if (this.immunization.programEligibility && this.immunization.programEligibility[0].coding) {
      const selectedprogramEligibility = this.programEligibilitys.find(
        (e) => e.code === this.immunization.programEligibility[0].coding[0].code,
      );
      this.immunizationEditForm.get('programEligibility').setValue(selectedprogramEligibility);
    }
    if (this.immunization.fundingSource && this.immunization.fundingSource.coding) {
      const selectedfundingSource = this.fundingSources.find(
        (e) => e.code === this.immunization.fundingSource.coding[0].code,
      );
      this.immunizationEditForm.get('fundingSource').setValue(selectedfundingSource);
    }
    if (this.immunization.performer && this.immunization.performer[0].function.coding[0]) {
      const selectedfunctions = this.functions.find(
        (e) => e.code === this.immunization.performer[0].function.coding[0].code,
      );
      this.immunizationEditForm.get('function').setValue(selectedfunctions);
    }

    if (this.isReadOnly) {
      this.immunizationEditForm.disable();
    }
  }

  prepareImmunization(): Immunization {
    const controls = this.immunizationEditForm.controls;
    const _immunization = new Immunization();
    _immunization.clear();
    _immunization.id = this.immunization.id;
    _immunization.status = controls.status.value;
    _immunization.statusReason = controls.statusReason.value;
    _immunization.vaccine = controls.vaccine.value;
    _immunization.recordedDate = this.datePipe.transform(controls.recordedDate.value, 'yyyy-MM-dd');
    _immunization.occurrence = this.datePipe.transform(controls.occurrence.value, 'yyyy-MM-dd');
    _immunization.note = controls.note.value;
    _immunization.primarySource = controls.primarySource.value;
    _immunization.reportOrigin = controls.reportOrigin.value;
    _immunization.lotNumber = controls.lotNumber.value;
    _immunization.site = controls.site.value;
    _immunization.route = controls.route.value;
    _immunization.expirationDate = this.datePipe.transform(
      controls.expirationDate.value,
      'yyyy-MM-dd',
    );
    _immunization.function = controls.function.value;
    _immunization.actorType = controls.actorType.value;
    _immunization.actor =
      controls.actorType.value === 'Practitioner' ? controls.actor1.value : controls.actor2.value;
    _immunization.reasonCode = controls.reasonCode.value;
    _immunization.isSubpotent = controls.isSubpotent.value;
    _immunization.subpotentReason = controls.subpotentReason.value;
    _immunization.presentationDate = this.datePipe.transform(
      controls.presentationDate.value,
      'yyyy-MM-dd',
    );
    _immunization.publicationDate = this.datePipe.transform(
      controls.publicationDate.value,
      'yyyy-MM-dd',
    );
    _immunization.documentType = controls.documentType.value;
    _immunization.reference = controls.reference.value;
    _immunization.programEligibility = controls.programEligibility.value;
    _immunization.fundingSource = controls.fundingSource.value;
    _immunization.targetDisease = controls.targetDisease.value;
    _immunization.doseNumber = controls.doseNumber.value;
    _immunization.seriesDoses = controls.seriesDoses.value;
    _immunization.series = controls.series.value;
    _immunization.doseQuantityUnit = controls.doseQuantityUnit.value;
    _immunization.doseQuantityValue = controls.doseQuantityValue.value;
    _immunization.condition = controls.conditionSearch.value;
    return _immunization;
  }

  onSubmit() {
    this.hasFormErrors = false;
    this.hasSubmissionErrors = false;
    const controls = this.immunizationEditForm.controls;
    if (this.immunizationEditForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    const editedImmunization = this.prepareImmunization();
    if (editedImmunization.id !== 0) {
      this.updateImmunization(editedImmunization);
    } else {
      this.createImmunization(editedImmunization);
    }
  }

  updateImmunization(_immunization: Immunization) {
    this.store.dispatch(
      new ImmunizationOnServerUpdated({
        immunization: _immunization,
        entityId: this.patientId,
      }),
    );
    this.store.pipe(select(selectImmunizationsActionLoading)).subscribe((res) => {
      if (res !== true) {
        this.store.pipe(select(selectImmunizationErrorState)).subscribe((error) => {
          if (error) {
            if (error.error.errors) {
              this.submissionErrorObj = error.error.errors;
            } else {
              this.submissionErrorObj = [{ message: 'GLOBAL.UNSPECIFIED_ERROR' }];
            }
            this.hasSubmissionErrors = true;
          } else {
            this.dialogRef.close({ _immunization, isEdit: true });
          }
        });
      }
    });
  }

  createImmunization(_immunization: Immunization) {
    this.store.dispatch(
      new ImmunizationOnServerCreated({ immunization: _immunization, entityId: this.patientId }),
    );
    this.store.pipe(select(selectImmunizationsActionLoading)).subscribe((res) => {
      if (res !== true) {
        this.store.pipe(select(selectImmunizationErrorState)).subscribe((error) => {
          if (error) {
            if (error.error.errors) {
              this.submissionErrorObj = error.error.errors;
            } else {
              this.submissionErrorObj = [{ message: 'GLOBAL.UNSPECIFIED_ERROR' }];
            }
            this.hasSubmissionErrors = true;
          } else {
            this.dialogRef.close({ _immunization, isEdit: false });
          }
        });
      }
    });
  }

  onAlertClose() {
    this.hasFormErrors = false;
  }

  getTitle() {
    let result = this.translate.instant('IMMUNIZATION.NEW_IMMUNIZATION');
    if (this.immunization !== undefined && !this.immunization.id) {
      return result;
    }
    if (this.isReadOnly) {
      result =
        this.translate.instant('IMMUNIZATION.VIEW_IMMUNIZATION') + `-` + this.immunization.id;
      return result;
    }
    result = this.translate.instant('IMMUNIZATION.EDIT_IMMUNIZATION') + `-` + this.immunization.id;
    return result;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.immunizationEditForm
      ? this.immunizationEditForm.controls[controlName]
      : null;
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  selectedVaccine(event: MatAutocompleteSelectedEvent): void {
    this.vaccineList.push(event.option.value);
    this.vaccineInput.nativeElement.value = event.option.value.concept.fsn.term;
  }

  vaccineInputChanged(value) {
    if (value) {
      if (typeof value === 'string')
        this.filteredVaccine = this.practitionRoleService.searchCode(value).pipe(
          map((res) =>
            res.items.filter((r) => {
              return !this.vaccineList.find((e: any) => e.concept.id === r.concept.id);
            }),
          ),
        );
    } else {
      this.filteredVaccine = of([]);
    }
  }

  displayFnVaccine(event: any): string {
    return event && event.display ? event.display : '';
  }

  selectedManifestation(event: MatAutocompleteSelectedEvent): void {
    this.manifestationList.push(event.option.value);
    this.manifestationInput.nativeElement.value = event.option.value.concept.fsn.term;
  }

  manifestationInputChanged(value) {
    if (value) {
      if (typeof value === 'string')
        this.filteredManifestation = this.practitionRoleService.searchCode(value).pipe(
          map((res) =>
            res.items.filter((r) => {
              return !this.manifestationList.find((e: any) => e.concept.id === r.concept.id);
            }),
          ),
        );
    } else {
      this.filteredManifestation = of([]);
    }
  }

  displayFnManifestation(event: any): string {
    return event && event.concept.fsn.term ? event.concept.fsn.term : '';
  }

  onCatChange(e) {
    const checkArray: FormArray = this.immunizationEditForm.get('checkArray') as FormArray;

    if (e.target.checked) {
      checkArray.push(new FormControl(e.target.value));
    } else {
      let i = 0;
      checkArray.controls.forEach((item: FormControl) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  selectedRecorder(event: MatAutocompleteSelectedEvent): void {
    this.recorderList.push(event.option.value);
    this.recorderInput.nativeElement.value = event.option.value.first_name;
  }

  recorderInputChanged(value, typeOfSelected) {
    if (value && (typeOfSelected === 'Patient' || typeOfSelected === 'Practitioner')) {
      if (typeof value === 'string' && typeOfSelected === 'Patient')
        this.filteredRecorder = this.patientsService.searchPatients(value).pipe(
          map((res) =>
            res.data.filter((r) => {
              return !this.recorderList.find((e: any) => e.id === r.id);
            }),
          ),
        );
      if (typeof value === 'string' && typeOfSelected === 'Practitioner')
        this.filteredRecorder = this.doctorsService.searchDoctors(value).pipe(
          map((res) =>
            res.data.filter((r) => {
              return !this.recorderList.find((e: any) => e.id === r.id);
            }),
          ),
        );
    } else {
      this.filteredRecorder = of([]);
    }
  }

  displayFnRecorder(event: any): string {
    return event && event.first_name + ' ' + event.last_name
      ? event.first_name + ' ' + event.last_name
      : '';
  }

  choseRecorderType(value) {
    this.recorderOption = value;
    this.recorderList = [];
    this.recorderInput.nativeElement.value = null;
  }

  selectedActor(event: MatAutocompleteSelectedEvent): void {
    this.actorList.push(event.option.value);
    if (this.actorInput) this.actorInput.nativeElement.value = event.option.value.first_name;
  }

  selectedPra(event: MatAutocompleteSelectedEvent): void {
    this.actorList1.push(event.option.value);
    if (this.actorInput1)
      this.actorInput1.nativeElement.value = event.option.value.specialty[0].coding[0].display;
  }

  actorInputChanged(value, typeOfSelected) {
    const olives = [];
    if (value && (typeOfSelected === 'PractitionerRole' || typeOfSelected === 'Practitioner')) {
      if (typeof value === 'string' && typeOfSelected === 'Practitioner')
        this.filteredActor = this.doctorsService.searchDoctors(value).pipe(
          map((res) =>
            res.data.filter((r) => {
              return !this.actorList.find((e: any) => e.id === r.id);
            }),
          ),
        );
      if (typeof value === 'string' && typeOfSelected === 'PractitionerRole')
        this.filteredActor = this.practitionRoleService
          .searchPractitionerRoles(value)
          .subscribe((res) => {
            for (let i = 0; res.entry.length > i; i++) {
              olives.push(res.entry[i].resource);
            }
            if (value) {
              if (typeof value === 'string')
                this.filteredPractitionerRole = olives.filter((r) => {
                  return !this.actorList1.find((e: any) => e.id === r.id);
                });
            } else {
              this.filteredPractitionerRole = of([]);
            }
          });
    } else {
      this.filteredActor = of([]);
    }
  }

  displayFnActor(event: any): string {
    return event && event.name && event.name[0] && event.name[0].given
      ? event.name[0].given[0]
      : '';
  }

  displayFnPra(event: any): string {
    return event &&
      event.specialty &&
      event.specialty[0] &&
      event.specialty[0].coding &&
      event.specialty[0].coding[0].display
      ? event.specialty[0].coding[0].display
      : '';
  }

  chooseActorType(value) {
    this.actorOption = value;
    this.actorList = [];
    this.actorList1 = [];
    if (this.actorInput) this.actorInput.nativeElement.value = null;
    if (this.actorInput1) this.actorInput1.nativeElement.value = null;
  }

  selectedReason(event: MatAutocompleteSelectedEvent): void {
    this.reasonList.push(event.option.value);
    this.reasonInput.nativeElement.value = event.option.value.concept.fsn.term;
  }

  reasonInputChanged(value) {
    if (value) {
      if (typeof value === 'string')
        this.filteredReason = this.practitionRoleService.searchCode(value).pipe(
          map((res) =>
            res.items.filter((r) => {
              return !this.reasonList.find((e: any) => e.concept.id === r.concept.id);
            }),
          ),
        );
    } else {
      this.filteredReason = of([]);
    }
  }

  displayFnReason(event: any): string {
    return event && event.concept.fsn.term ? event.concept.fsn.term : '';
  }

  selectedReasonCode(event: MatAutocompleteSelectedEvent): void {
    this.reasonCodeList.push(event.option.value);
    this.reasonCodeInput.nativeElement.value = event.option.value.concept.fsn.term;
  }

  reasonCodeInputChanged(value) {
    if (value && typeof value === 'string')
      this.filteredReasonCode = this.practitionRoleService.searchCode(value).pipe(
        map((res) =>
          res.items.filter((r) => {
            return !this.reasonCodeList.find((e: any) => e.concept.id === r.concept.id);
          }),
        ),
      );
    this.filteredReasonCode = of([]);
  }

  displayFnReasonCode(event: any): string {
    return event && event.concept.fsn.term ? event.concept.fsn.term : '';
  }

  selectedTargetDisease(event: MatAutocompleteSelectedEvent): void {
    this.targetDiseaseList.push(event.option.value);
    this.targetDiseaseInput.nativeElement.value = event.option.value.concept.fsn.term;
  }

  targetDiseaseInputChanged(value) {
    if (value && typeof value === 'string')
      this.filteredTargetDisease = this.practitionRoleService.searchCode(value).pipe(
        map((res) =>
          res.items.filter((r) => {
            return !this.targetDiseaseList.find((e: any) => e.concept.id === r.concept.id);
          }),
        ),
      );
    this.filteredTargetDisease = of([]);
  }

  displayFnTargetDisease(event: any): string {
    return event && event.concept.fsn.term ? event.concept.fsn.term : '';
  }

  selectedCondition(event: MatAutocompleteSelectedEvent): void {
    this.conditionList.push(event.option.value);
    this.conditionInput.nativeElement.value = event.option.value.code.coding[0].display;
  }

  conditionInputChanged(value) {
    const olives = [];
    if (value) {
      this.conditionsService.searchConditions(this.patientId, value).subscribe((res) => {
        for (let i = 0; res.entry.length > i; i++) {
          olives.push(res.entry[i].resource);
        }
        if (value) {
          if (typeof value === 'string')
            this.filteredCondition = olives.filter((r) => {
              return !this.conditionList.find((e: any) => e.id === r.id);
            });
        } else {
          this.filteredCondition = [];
        }
      });
    }
  }

  displayFnCondition(event: any): string {
    return event && event.code && event.code.coding && event.code.coding[0].display
      ? event.code.coding[0].display
      : '';
  }
}
